export const LOAD_BOOKING_SLOTS = "bookings/LOAD_BOOKING_SLOTS";
export const CREATE_BOOKINGS = "bookings/CREATE_BOOKINGS";
export const UPDATING_AVAILABILITY = "bookings/UPDATING_AVAILABILITY";
export const UPDATED_AVAILABILITY = "bookings/UPDATED_AVAILABILITY";
export const CHANGING_DURATION = "bookings/CHANGING_DURATION";
export const TOGGLE_SLOT_AVAILABILITY = "bookings/TOGGLE_SLOT_AVAILABILITY";
export const UPDATING_SHIFTS = "bookings/UPDATING_SHIFTS";
